import {useEffect, useRef, useState} from 'react'
import './ItemChat.css'
import {defaultAvatarUrl} from '@utils/Const'
import learnRequest from '@apis/learn'
import {
  Box,
  Center,
  CircularProgress,
  CircularProgressLabel,
  Flex,
  Icon,
  Image,
  Text,
  Tooltip,
} from '@chakra-ui/react'
import {ReactComponent as MicIcon} from '@assets/svgs/learn/message.svg'
import {Modal} from 'antd'
import Volume from '@assets/svgs/volume.svg'
import headphoneIcon from '@assets/svgs/learn/headphone.svg'
import appRequest from '@apis/app'
import GlobalMic3 from '@components/GlobalMic3'

const ItemUserMessage = ({
  message,
  isHidden,
  audioFileUser,
  isLoading,
}: any) => {
  const [speechCheckData, setSpeechCheckData] = useState<any>()
  const [speechCheckDataBest, setSpeechCheckDataBest] = useState<any>()
  const [speechCheckDataList, setSpeechCheckDataList] = useState<any>([])
  const [wordInfo, setWordInfo] = useState<any>()
  const [isShowModal, setIsShowModal] = useState(false)
  const audioRef = useRef<any>()

  useEffect(() => {
    getSpeechCheck()
    getWordInfo()
  }, [])

  useEffect(() => {
    if (speechCheckDataBest) {
      setSpeechCheckData(speechCheckDataBest)
    }
  }, [isShowModal])

  useEffect(() => {
    if (speechCheckDataList) {
      const maxScoreItem = speechCheckDataList.reduce(
        (max: any, item: any) =>
          item?.total_score > max?.total_score ? item : max,
        speechCheckDataList[0],
      )
      setSpeechCheckDataBest(maxScoreItem)
    }
  }, [speechCheckDataList])

  const getSpeechCheck = async () => {
    if (!audioFileUser) return
    try {
      const formData = new FormData()
      formData.append('audio-file', audioFileUser)
      formData.append('text-refs', message?.message)
      const res = await learnRequest.getSpeechCheck(formData)
      setSpeechCheckData(res?.data?.data)
      setSpeechCheckDataList([res?.data?.data])
    } catch (error) {}
  }

  const getColorByScore = (score: any) => {
    if (score >= 75) return '#45BB66'
    if (score >= 60) return '#FFCD00'
    if (score >= 0) return '#E55856'
  }

  const getToolTipByScore = (score: any) => {
    if (score >= 75) return 'Phát âm tốt'
    if (score >= 50) return 'Phát âm gần đúng'
    if (score >= 0) return 'Phát âm chưa tốt'
  }

  const handleCloseModal = () => {
    setIsShowModal(false)
  }

  const handleStartRecording = () => {
    if (audioRef.current) {
      audioRef.current.pause()
    }
  }

  const handleRecordingComplete = async (blob: any) => {
    let file = new File([blob], 'audio.wav', {type: 'audio/wav'})
    const formData = new FormData()
    formData.append('audio-file', file)
    formData.append('text-refs', message?.message)
    const res = await learnRequest.getSpeechCheck(formData)
    setSpeechCheckData(res?.data?.data)
    setSpeechCheckDataList((pre: any) => [...pre, res?.data?.data])
  }

  const getWordInfo = async () => {
    try {
      const params = {text: message?.message}
      const res = await appRequest.getWordInfo(params)
      setWordInfo(res.data.data)
    } catch (error) {}
  }

  const handlePlayAudio = (url: any) => {
    if (audioRef.current) {
      audioRef.current.pause()
    }
    audioRef.current = new Audio(url)
    audioRef.current.play()
  }

  const compareText = (data: any) => {
    let text = ''
    data?.result?.forEach((word: any) => {
      word.letters.forEach((char: any) => {
        text += char.letter
      })
    })
    return !!text
  }

  return (
    <Flex
      w={'95%'}
      ml={'auto'}
      gap={{base: '10px', md: '16px'}}
      flexDirection={'row-reverse'}>
      <Image
        src={defaultAvatarUrl}
        alt="Avatar"
        w={{base: '32px', md: '40px'}}
        h={{base: '32px', md: '40px'}}
      />
      {isHidden ? (
        <Box
          bg={'white'}
          borderRadius={'24px'}
          boxShadow={
            '0 4px 8px 0 rgba(0, 0, 0, 0.05), 0 6px 20px 0 rgba(0, 0, 0, 0.05)'
          }
          padding={{base: '10px', md: '16px'}}>
          {'**************'}
        </Box>
      ) : (
        <Box
          bg={'white'}
          borderRadius={'24px'}
          boxShadow={
            '0 4px 8px 0 rgba(0, 0, 0, 0.05), 0 6px 20px 0 rgba(0, 0, 0, 0.05)'
          }
          padding={{base: '10px', md: '16px'}}>
          {message?.message}
        </Box>
      )}
      {speechCheckData && (
        <Flex
          alignItems={'center'}
          pointerEvents={isLoading ? 'none' : 'unset'}>
          <Box>
            <Tooltip
              label={getToolTipByScore(speechCheckData?.total_score * 100)}>
              <Icon
                opacity={isLoading ? 0.5 : 1}
                w={'24px'}
                h={'24px'}
                cursor={'pointer'}
                sx={{
                  fill: getColorByScore(speechCheckData?.total_score * 100),
                }}
                onClick={() => setIsShowModal(true)}>
                <MicIcon />
              </Icon>
            </Tooltip>
          </Box>
        </Flex>
      )}
      <Modal
        title={null}
        centered={true}
        footer={null}
        open={isShowModal}
        onCancel={handleCloseModal}>
        <Flex gap={'16px'}>
          <Image
            src={Volume}
            cursor={'pointer'}
            w={'40px'}
            onClick={() => handlePlayAudio(wordInfo?.audio)}
          />
          <Box>
            <Text fontSize={'20px'} fontWeight={600}>
              {compareText(speechCheckData) ? (
                speechCheckData?.result.map((word: any, index: any) => (
                  <Text key={index} as={'span'}>
                    {word.letters.map((char: any, index: any) => (
                      <Text
                        key={index}
                        as={'span'}
                        color={getColorByScore(char.score * 100)}>
                        {char.letter}
                      </Text>
                    ))}{' '}
                  </Text>
                ))
              ) : (
                <Text as={'span'} color={'red'}>
                  {`${wordInfo?.text}` || ''}
                </Text>
              )}
            </Text>
            <Text fontSize={'16px'}>{wordInfo?.ipa}</Text>
          </Box>
        </Flex>
        <Flex
          flexDirection={'column'}
          alignItems={'center'}
          gap={'16px'}
          mt={'16px'}>
          <CircularProgress
            value={Math.floor(speechCheckData?.total_score * 100) || 0}
            color={getColorByScore(speechCheckData?.total_score * 100)}
            size={'100'}
            thickness="4px">
            <CircularProgressLabel
              fontSize={'48px'}
              fontWeight={600}
              color={getColorByScore(speechCheckData?.total_score * 100)}>
              {speechCheckData
                ? Math.floor(speechCheckData?.total_score * 100)
                : 0 || '--'}
            </CircularProgressLabel>
          </CircularProgress>
          <Text fontSize={'16px'} fontWeight={600} color={'#AAAAAA'}>
            {speechCheckDataList?.length >= 3
              ? 'Bạn hãy học tiếp nhé!'
              : 'Hãy thử phát âm lại nhé!'}
          </Text>
          <Flex gap={'28px'} alignItems={'center'}>
            <Tooltip label="Nghe lại phát âm của bạn">
              <Center
                w={'40px'}
                h={'40px'}
                bg={'#eaf6fe'}
                borderRadius={'100%'}
                cursor={'pointer'}
                onClick={() => handlePlayAudio(speechCheckData?.audio_url)}>
                <Image
                  w={'20px'}
                  h={'20px'}
                  opacity={0.7}
                  src={headphoneIcon}
                />
              </Center>
            </Tooltip>
            <GlobalMic3
              isDisabled={speechCheckDataList?.length >= 3}
              handleStartRecording={handleStartRecording}
              handleRecordingComplete={handleRecordingComplete}
            />
            <Box w={'40px'} />
          </Flex>
        </Flex>
      </Modal>
    </Flex>
  )
}

export default ItemUserMessage
